module.exports = __webpack_public_path__ + "3182ab6c3c782171878eaea3f102967c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MetaPro-Bold/MetaPro-Bold.eot
// module id = 133
// module chunks = 0